export const SkillsData = [
    {
        type: "Frontend",
        list:[
            {
                name:"React.Js",
                icon: <i class="devicon-react-original colored"></i>
            },
            {
                name:"Redux",
                icon: <i class="devicon-redux-original colored"></i> 
            },   
            // {
            //     name:"Next.Js",
            //     icon: <i class="devicon-nextjs-original colored"></i>    
            // },
            // {
            //     name:"TypeScript",
            //     icon:  <i class="devicon-typescript-plain colored"></i>
            // },
            {
                name:"JavaScript",
                icon: <i class="devicon-javascript-plain colored"></i>
            },
            {
                name:"HTML",
                icon: <i class="devicon-html5-plain colored"></i>
            },
            {
                name:"CSS",
                icon: <i class="devicon-css3-plain colored"></i>    
            },
            {
                name:"Tailwind CSS",
                icon: <i class="devicon-tailwindcss-plain colored"></i>
            },
            {
                name:"Bootstrap",
                icon: <i class="devicon-bootstrap-plain colored"></i>
            },
            {
                name:"WordPress",
                icon: <i class="devicon-wordpress-plain colored"></i>
            },
        ]
    },
    {
        type:"Backend",
        list:[
            {
                name:"Node Js",
                icon: <i class="devicon-nodejs-plain colored"></i>
            },
            // {
            //     name:"GO",
            //     icon: <i class="devicon-go-original-wordmark colored"></i>
            // },
            {
                name:"C++",
                icon: <i class="devicon-cplusplus-plain colored"></i>
            },
            {
                name:"MongoDB",
                icon: <i class="devicon-mongodb-plain colored"></i>
            },
            {
                name:"MySql",
                icon: <i class="devicon-mysql-plain colored"></i>
            },
        ]
    }
]